import { PropertyType } from '../../../common';

export const mapEntityToApi = (data: PropertyType): PropertyType => {
	const { token, form, provider, partner } = data;
	const apiData: PropertyType = {
		sid: token,
		provider,
		partner,
		short_name_live: form.short_name_live,
		short_name_test: form.short_name_test,
	};

	return apiData;
};
